import { NgFor } from "@angular/common";
import { Component } from "@angular/core";
import { NgbToastModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastService } from "../../services/toast.service";
import { TimeDifferencePipe } from "../../directives/time-difference.pipe";

@Component({
  selector: "app-toasts-container",
  standalone: true,
  imports: [NgbToastModule, NgFor, TimeDifferencePipe],
  template: `<ngb-toast
    *ngFor="let toast of toastService.toasts"
    [class]="toast.classname"
    [autohide]="false"
    [delay]="toast.delay || 30000"
    (hidden)="toastService.remove(toast)"
  >
    <ng-template ngbToastHeader>
      <div class="me-auto d-flex justify-content-center align-items-center">
        <i [class]="toast.icon"></i>
        <strong class="mx-1 fw-bold">{{ toast.header }}</strong>
      </div>
    </ng-template>
    <p class="text-dark mb-1 fs-12">{{ toast.message }}</p>
    <div class="text-end fs-11">
      <small class="text-muted">
        {{ toast.timer | timeDifference }}
      </small>
    </div>
  </ngb-toast>`,
  host: {
    class: "toast-container position-fixed bottom-0 end-0 p-3 pb-5",
    style: "z-index: 1200",
  },
  styles: [
    `
      .btn-close {
        box-sizing: unset !important;
        width: 0.5em !important;
        height: 0.5em !important;
        padding: 0 !important;
      }
    `,
  ],
})
export class ToastsContainerComponent {
  constructor(public toastService: ToastService) {}
}
